import { MapPin, Store } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useAuth } from 'shared/hooks/useAuth';
import { ARENA_OWNER_SIGNUP, ROUTES } from 'shared/constants/routes';
import { UserRole } from 'shared/types/user';
import { NotificationsBell } from 'shared/components/layout/NotificationsBell';
import { Avatar } from 'shared/components/ui/Avatar';
import { BrandLogo } from 'shared/components/brand/BrandLogo';

// Atalho principal de cada persona, ao lado de "Início".
const ROLE_LINK: Partial<Record<UserRole, { to: string; label: string }>> = {
  jogador: { to: ROUTES.BOOKING, label: 'Reservar Quadra' },
  arena: { to: ROUTES.ARENA_DASHBOARD, label: 'Painel da Arena' },
  admin: { to: ROUTES.ADMIN_DASHBOARD, label: 'Administração' },
  instrutor: { to: ROUTES.INSTRUCTOR_CLASSES, label: 'Minhas Turmas' },
  recepcao: { to: ROUTES.RECEPCAO_RESERVATIONS, label: 'Reservas' },
};

export function Header() {
  const { user } = useAuth();
  const roleLink = user ? ROLE_LINK[user.role] : undefined;

  return (
    <header className="flex items-center justify-between gap-4 border-b border-border/60 bg-surface px-4 py-3 sm:px-8 sm:py-4">
      <Link to={ROUTES.HOME} aria-label="Marcô, ir para o início" className="flex flex-shrink-0 items-center gap-2.5">
        <BrandLogo />
        <span className="hidden items-center gap-1 rounded-full bg-chip px-3 py-1 text-xs font-medium text-ink-secondary lg:inline-flex">
          <MapPin className="h-3.5 w-3.5" aria-hidden="true" />
          Fortaleza-CE
        </span>
      </Link>

      {/* No celular os atalhos de texto somem (o jogador tem a barra inferior e as demais
          personas o menu da própria área); ficam só o sino e o avatar. */}
      <nav className="flex min-w-0 items-center gap-3 text-sm text-ink-secondary sm:gap-5">
        <Link to={ROUTES.HOME} className="hidden hover:text-ink md:inline">
          Início
        </Link>
        {roleLink && (
          <Link to={roleLink.to} className="hidden whitespace-nowrap hover:text-ink md:inline">
            {roleLink.label}
          </Link>
        )}

        {user && <NotificationsBell />}

        {user ? (
          <Link
            to={ROUTES.PROFILE}
            className="flex min-w-0 items-center gap-2 font-medium text-ink hover:text-primary"
            title={user.name}
          >
            <Avatar name={user.name} size="sm" />
            <span className="hidden max-w-[160px] truncate sm:inline">{user.name}</span>
          </Link>
        ) : (
          <>
            {/* Dono de arena acha a porta de entrada no topo de qualquer página, sem rolar. */}
            <Link
              to={ARENA_OWNER_SIGNUP}
              className="flex items-center gap-1.5 whitespace-nowrap rounded-lg border border-border px-3 py-1.5 font-medium text-ink transition-colors hover:border-primary hover:text-primary-dark sm:px-3.5"
            >
              <Store className="h-4 w-4" aria-hidden="true" />
              <span className="sm:hidden">Para arenas</span>
              <span className="hidden sm:inline">Cadastrar minha arena</span>
            </Link>
            <Link
              to={ROUTES.LOGIN}
              className="whitespace-nowrap rounded-lg bg-primary px-4 py-1.5 font-medium text-surface transition-colors hover:bg-primary-dark"
            >
              Entrar
            </Link>
          </>
        )}
      </nav>
    </header>
  );
}
